module.exports={
	"Form": "FundingSourceViewManifest",
	"Scope": "FundingSource-View",
	"Descriptors":
	{
		"FundingSourceDetails.Name":
		{
			"Name": "Name",
			"Hash": "FundingSource-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "FundingSource-View-Identity",
				"Group": "FundingSource-View-Identity"
			}
		},
		"FundingSourceDetails.FundingSourceAccountCode":
		{
			"Name": "Funding Source Account Code",
			"Hash": "FundingSource-View-FundingSourceAccountCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "FundingSource-View-Identity",
				"Group": "FundingSource-View-Identity"
			}
		},
		"FundingSourceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "FundingSource-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.Description":
		{
			"Name": "Description",
			"Hash": "FundingSource-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "FundingSource-View-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.Type":
		{
			"Name": "Type",
			"Hash": "FundingSource-View-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "FundingSource-View-Details",
				"Group": "FundingSource-View-Details"
			}
		},
		"FundingSourceDetails.IDFundingSource":
		{
			"Name": "IDFunding Source",
			"Hash": "FundingSource-View-IDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.GUIDFundingSource":
		{
			"Name": "GUIDFunding Source",
			"Hash": "FundingSource-View-GUIDFundingSource",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "FundingSource-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "FundingSource-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "FundingSource-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		},
		"FundingSourceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "FundingSource-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "FundingSource-View-DataAudit",
				"Group": "FundingSource-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "FundingSource-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "FundingSource-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "FundingSource-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "FundingSource-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "FundingSource-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "FundingSource-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
